import React from "react"
import { Table } from "antd"
import PropTypes from "prop-types"

const DataTable = ({ columns, dataSource, rowSelection, loading, pagination, onChange, onRowClick, rowClickKey, ...restProps }) => {
  const handleRowClick = (record) => {
    if (onRowClick && rowClickKey) {
      onRowClick(record[rowClickKey], record)
    }
  }
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowSelection={rowSelection}
      pagination={pagination}
      loading={loading}
      onChange={onChange}
      rowKey={rowClickKey}
      onRow={(record) => ({
        onClick: onRowClick ? () => handleRowClick(record) : undefined,
        style: onRowClick ? { cursor: "pointer" } : {},
      })}
      {...restProps}
    />
  )
}

DataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array.isRequired,
  rowSelection: PropTypes.object,
  loading: PropTypes.bool,
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onChange: PropTypes.func,
  onRowClick: PropTypes.func,
  rowClickKey: PropTypes.string
}

DataTable.defaultProps = {
  rowSelection: null,
  loading: false,
  pagination: {},
  onChange: () => {},
  onRowClick: null,
  rowClickKey: "key"
}

export default DataTable
